import classNames from 'classnames'
import { useEffect, useRef } from 'react'

import HeaderScrollHandler from '../HeaderScrollHandler/HeaderScrollHandler'
import Card from '../ui/Card/Card'
import Image from '../ui/Image/Image'

import useHorizontalScroll from '../../hooks/useHorizontalScroll'
import { getImageUrl, isArabic } from '../../utils'

import styles from './Campaign.module.scss'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

const CampaignTabs = ({
  tabs,
  selectedTab,
  onTabClick,
  children,
  avoidRtl,
}) => {
  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll(200, avoidRtl)
  const selectedTabRefs = useRef({})
  const { language } = useLanguage()

  useEffect(() => {
    const scrollToView = () => {
      const activeTabref = selectedTabRefs.current?.[selectedTab?.countrycode]
      if (activeTabref && scrollRef.current) {
        const left = activeTabref.offsetLeft - (window.innerWidth * 15) / 100
        scrollRef.current.scroll({
          left,
          behavior: 'smooth',
        })
      }
    }
    scrollToView()
  }, [selectedTab])

  return (
    <div className={classNames(styles.tabsVisibility)}>
      <div className={classNames(styles.tabsContainer)}>
        <HeaderScrollHandler
          scrollLeft={scrollLeft}
          scrollRight={scrollRight}
          isAtStart={isAtStart}
          isAtEnd={isAtEnd}
          className={classNames('page-container')}
          avoidRtl={avoidRtl}
        />
        <div ref={scrollRef} className={classNames(styles.cardContainer)}>
          {tabs?.map((tab) => (
            <Card
              ref={(el) => (selectedTabRefs.current[tab?.countrycode] = el)}
              key={tab.country_name + tab?.countrycode}
              className={classNames(styles.cardHolder, {
                [styles.active]: tab?.countrycode === selectedTab?.countrycode,
                [styles.arabic_cardHolder]:
                  !avoidRtl && isArabic(language?.code),
              })}
              onClickHandler={() => {
                onTabClick(tab)
              }}
            >
              {tab?.country_logo && (
                <Image
                  className={styles.tabIcon}
                  src={getImageUrl(tab.country_logo)}
                  alt={tab?.country_logo?.alternativeText}
                />
              )}
              <span>{tab.country_name}</span>
            </Card>
          ))}
        </div>
      </div>
      <div>{children}</div>
    </div>
  )
}

export default CampaignTabs
